import {
  CompWithFormProp,
  FormConfigProps,
} from '../../../constants/constants';
import { DynamicFormField } from '../../DynamicFormField';

export const subjectScienceConfig: Record<string, FormConfigProps> = {
  usedVisualAid: {
    label:
      'naudojamos vaizdinės priemonės, iliustruojančios sąvokas / procesus',
    value: 'usedVisualAid',
  },
  simplifiedLabWork: {
    label:
      'skiriami supaprastinti eksperimentai / laboratoriniai darbai su aiškiais galutiniais rezultatais',
    value: 'simplifiedLabWork',
  },
  labWorkIndividualDiscussion: {
    label:
      'individualiai aptariama eksperimentų / laboratorinių darbų atlikimo eiga',
    value: 'labWorkIndividualDiscussion',
  },
  labWorkVisualExample: {
    label:
      'vizualiai pateikiama eksperimentų / laboratorinių darbų atlikimo eiga',
    value: 'labWorkVisualExample',
  },
  labWorkIndividualAssistance: {
    label:
      'eksperimentai / laboratoriniai darbai atliekami teikiant individualią pagalbą',
    value: 'labWorkIndividualAssistance',
  },
  labWorkSmallGroups: {
    label: 'eksperimentai / laboratoriniai darbai atliekami mažose grupėse',
    value: 'labWorkSmallGroups',
  },
  referencesToStepsAndSequence: {
    label:
      'pateikiamos nuorodos apie uždavinio sprendimo veiksmus ir jų eiliškumą',
    value: 'referencesToStepsAndSequence',
  },
};

export const SubjectScience = ({ form }: CompWithFormProp) => {
  return (
    <DynamicFormField
      formItemConfig={subjectScienceConfig}
      formPathParams={['subject', 'block3', 'methods']}
      form={form}
    />
  );
};
